const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  pageSize: 5,
  paginationPage: 1,
  nbResult: 0,
  organizationId: 0,
  error: null,
};

export const rankingClientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZED_RANKING_CLIENTS': {
      return initialState;
    }
    case 'FETCH_RANKING_CLIENTS_PENDING': {
      return { ...state, fetching: true };
    }
    case 'FETCH_RANKING_CLIENTS_FULFILLED': {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult,
      };
    }
    case 'FETCH_RANKING_CLIENTS_REJECTED': {
      let error = action.payload;
      switch (error.response?.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error,
      };
    }
    case 'SET_RANKING_CLIENT_ORGANIZATION_ID': {
      const { organizationId } = action;
      return { ...state, organizationId };
    }
    default:
      return state;
  }
};

const initialStateForRankingClientsSort = {
  sortConfig: {
    columnKey: 'score',
    sortDirection: 'desc',
  },
};

export const rankingClientsSortReducer = (state = initialStateForRankingClientsSort, action) => {
  switch (action.type) {
    case 'INITIALIZED_RANKING_CLIENTS': {
      return initialStateForRankingClientsSort;
    }
    case 'SET_RANKING_CLIENTS_LIST_SORT_CONFIG': {
      return { ...state, sortConfig: action.config };
    }
    default:
      return state;
  }
};
